
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moving-and-storage-services",
      function () {
        return require("private-next-pages/moving-and-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moving-and-storage-services"])
      });
    }
  